import React, { FC, useCallback } from 'react';
import {
  DATE_FORMAT, useViewModel,
} from '@utils';
import {
  Clock, TimePicker, DatePicker, MeetingViewModel,
} from '@components';
import {
  addMinutes, differenceInMinutes, format,
} from 'date-fns';

interface DateBlockProp {
  onUpdateMeeting: (property: 'startDate' | 'endDate', value: Date) => void;
  isEdit: boolean;
  showError: boolean;
}

export const MobileDateBlock: FC<DateBlockProp> = ({
  onUpdateMeeting, isEdit, showError,
}) => {
  const meetingViewModel = useViewModel(MeetingViewModel);

  const checkInvalidDate = (newDate: Date, oldDate: Date) => {
    if (!newDate || newDate.toString() === 'Invalid Date') {
      const correctedDate = new Date(oldDate);
      correctedDate.setHours(0);
      correctedDate.setMinutes(0);
      correctedDate.setSeconds(0);
      correctedDate.setMilliseconds(0);
      return correctedDate;
    }
    newDate.setSeconds(0);
    newDate.setMilliseconds(0);
    return newDate;
  };

  const adjustEndDate = useCallback((checkedDate: Date, minutesDelta: number, changedTime: boolean) => {
    if (addMinutes(checkedDate, minutesDelta).getDate() > meetingViewModel.meetingData.startDate.getDate() && changedTime) {
      checkedDate.setHours(23);
      checkedDate.setMinutes(59);
      changeEndDate(checkedDate);
    } else {
      changeEndDate(addMinutes(checkedDate, minutesDelta));
    }
  }, [meetingViewModel.meetingData.startDate]);

  const changeStartDate = useCallback((newDate: Date) => {
    const minutesDelta = differenceInMinutes(meetingViewModel.meetingData.endDate, meetingViewModel.meetingData.startDate);
    const checkedDate = checkInvalidDate(newDate, meetingViewModel.meetingData.startDate);
    const changedTime = format(newDate, DATE_FORMAT) === format(meetingViewModel.meetingData.startDate, DATE_FORMAT);
    onUpdateMeeting('startDate', checkedDate);
    adjustEndDate(checkedDate, minutesDelta, changedTime);
  }, [meetingViewModel.meetingData.startDate, meetingViewModel.meetingData.endDate]);

  const changeEndDate = useCallback((newDate: Date) => {
    onUpdateMeeting('endDate', checkInvalidDate(newDate, meetingViewModel.meetingData.endDate));
  }, [meetingViewModel.meetingData.endDate]);

  const currentDate = new Date();

  return (
    <div className="area date mobile-date">
      <Clock divClassName="block-icon clock" />
      <div>
        <div className="input-block mobile">
          <div>Начало</div>
          <div className="date-time-block">
            <DatePicker
              readOnly={!isEdit}
              value={meetingViewModel.meetingData.startDate}
              classNameInput="date-picker-edit-meeting"
              onChange={changeStartDate}
              />
            <TimePicker
              readOnly={!isEdit}
              value={meetingViewModel.meetingData.startDate}
              onChange={(date) => changeStartDate(date)}
              error={showError && meetingViewModel.meetingData.startDate.getTime() < currentDate.getTime() && isEdit}
            />
          </div>
          {showError && meetingViewModel.meetingData.startDate.getTime() < new Date().getTime() && isEdit && (
            <div className="error-text">Время начала встречи не может быть меньше текущего</div>
            )}
          <div>Конец</div>
          <div className="date-time-block">
            <DatePicker
              readOnly
              value={meetingViewModel.meetingData.endDate}
              classNameInput="date-picker-edit-meeting"
              onChange={changeEndDate}
            />
            <TimePicker
              readOnly={!isEdit}
              value={meetingViewModel.meetingData.endDate}
              onChange={(date) => changeEndDate(date)}
              error={showError && meetingViewModel.meetingData.startDate.getTime() > meetingViewModel.meetingData.endDate.getTime()}
            />
          </div>
        </div>
        {showError && meetingViewModel.meetingData.startDate.getTime() > meetingViewModel.meetingData.endDate.getTime() && (
          <div className="error-text">Создать встречу можно только до конца дня</div>
        )}
      </div>
    </div>
  );
};
